/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShoptetIntegrationData
 */
export interface ShoptetIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ShoptetIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShoptetIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationData
     */
    knownStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationData
     */
    unpaidOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationData
     */
    completedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationData
     */
    refundedOrderStatuses?: Array<string>;
}

/**
 * Check if a given object implements the ShoptetIntegrationData interface.
 */
export function instanceOfShoptetIntegrationData(value: object): value is ShoptetIntegrationData {
    return true;
}

export function ShoptetIntegrationDataFromJSON(json: any): ShoptetIntegrationData {
    return ShoptetIntegrationDataFromJSONTyped(json, false);
}

export function ShoptetIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoptetIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'project': json['project'] == null ? undefined : json['project'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
        'knownStatuses': json['knownStatuses'] == null ? undefined : json['knownStatuses'],
        'unpaidOrderStatuses': json['unpaidOrderStatuses'] == null ? undefined : json['unpaidOrderStatuses'],
        'completedOrderStatuses': json['completedOrderStatuses'] == null ? undefined : json['completedOrderStatuses'],
        'refundedOrderStatuses': json['refundedOrderStatuses'] == null ? undefined : json['refundedOrderStatuses'],
    };
}

export function ShoptetIntegrationDataToJSON(json: any): ShoptetIntegrationData {
    return ShoptetIntegrationDataToJSONTyped(json, false);
}

export function ShoptetIntegrationDataToJSONTyped(value?: ShoptetIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'project': value['project'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'knownStatuses': value['knownStatuses'],
        'unpaidOrderStatuses': value['unpaidOrderStatuses'],
        'completedOrderStatuses': value['completedOrderStatuses'],
        'refundedOrderStatuses': value['refundedOrderStatuses'],
    };
}

